import AbstractController from "@/Controller/AbstractController";

export default class PartnerRegistration extends AbstractController {
    constructor() {
        super();

        this.el = document.querySelector('.partner-reg');
        this.form = this.el.querySelector('form');
        this.accept1Element = this.el.querySelector('input[name="accept1"]');
        this.accept2Element = this.el.querySelector('input[name="accept2"]');
        this.submitButton = this.el.querySelector('.partner-reg__form-submit');
        $(this.el.querySelector('select[name="delivery"]')).select2({ minimumResultsForSearch: Infinity });

        this.bind();
    }

    bind() {
        this.el.querySelector('.partner-reg__add-address').addEventListener('click', this.onAddressAdd.bind(this));
        this.form.addEventListener('submit', (e) => e.preventDefault());
        this.submitButton.addEventListener('click', this.onButtonSubmit.bind(this));
        this.accept1Element.addEventListener('change', this.updateSubmitButtonState.bind(this));
        this.accept2Element.addEventListener('change', this.updateSubmitButtonState.bind(this));
    }

    onAddressAdd(e) {
        const inputs = this.el.querySelectorAll('.partner-reg__address-input');

        if (inputs.length >= 5) {
            return;
        }

        const newInput = inputs[inputs.length - 1].cloneNode();
        newInput.value = '';
        newInput.id = '';
        inputs[0].parentElement.append(newInput);

        if (inputs.length >= 4) {
            this.el.querySelector('.partner-reg__add-address').disabled = true;
        }
    }

    updateSubmitButtonState() {
        this.submitButton.disabled = !(this.accept1Element.checked && this.accept2Element.checked);
    }

    async onButtonSubmit(e) {
        const form = this.el.querySelector('form');

        /*if (form.reportValidity() === false) {
            form.classList.add('ui-form-show-validation');
            return;
        }*/

        const formData = new FormData(form);
        formData.append('sessid', BX.message('bitrix_sessid'));

        let protect = form.dataset.protect;
        protect = protect.slice(-4) + protect.slice(0, -4);
        formData.append('_protect', protect);

        let response;

        try {
            response = await BX.ajax.runComponentAction('nav:form', 'submit', {
                mode: 'class',
                data: formData,
            });
        } catch (response) {
            let errors = response.errors.map(error => error.message).join('\n');
            alert(errors);
            return;
        }

        if (!response.data) {
            alert('Произошла ошибка, попробуйте ещё раз');
            return;
        }

        document.querySelector('.partner-reg__success').classList.remove('hidden');
        window.scrollTo(0, 0);
        document.querySelector('.partner-reg__form').classList.add('hidden');
    }
}